export default __webpack_public_path__ + "files/media/s-private.f79aa051.jpg";